import React, { useState } from 'react';
import "./assets/Header.css";
import contactTeam from "./assets/contact.svg";
import FAQModal from "./FAQModal";



function Footer({ onChatOpen, showChatButton = true }) {
    const [isFAQOpen, setIsFAQOpen] = useState(false);

    const message = `Qualcomm Confidential and Proprietary. Copyright © 2025 QUALCOMM incorporated.\nAll Rights Reserved. May contain U.S. or international export controlled information.`;

    const formattedMessage = message.split('\n').map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ));

    return (
        <>
            <div className="footer">
                <div className='row-footer'>
                    <button className="qualcomm-icon-btn"></button>
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px', marginRight: '3em' }}>
                        <a className="button-with-image" href="mailto:wbc.server.sw@qti.qualcomm.com" target="_blank" style={{ marginLeft: '0', marginRight: '0' }}>
                            <img className="image-inside-button" src={contactTeam} alt="Contact"/>
                            <span>Contact</span>
                        </a>
                        <button
                            className="button-with-image"
                            onClick={() => setIsFAQOpen(true)}
                            style={{ marginLeft: '0', marginRight: '0', background: 'none', border: 'none', cursor: 'pointer' }}
                        >
                            <span>FAQ</span>
                        </button>
                    </div>
                </div>
                <div className='footer-detail-section'>
                    <p>{formattedMessage}</p>
                </div>
            </div>
            
            {isFAQOpen && <FAQModal onClose={() => setIsFAQOpen(false)} />}

            {/* WBC Chat Button - hidden for restricted groups */}
            {showChatButton && (
                <button className="wbc-floating-chat-button" onClick={onChatOpen}>
                    <svg viewBox="0 0 24 24">
                        <path d="M12 1c-6.338 0-12 4.226-12 10.007 0 2.05.739 4.063 2.047 5.625l-1.993 6.368 6.946-3c1.705.439 3.334.641 4.864.641 7.174 0 12.136-4.439 12.136-9.634 0-5.812-5.701-10.007-12-10.007zm0 1.5c5.486 0 10.5 3.487 10.5 8.507 0 4.506-4.273 8.134-10.636 8.134-1.466 0-3.011-.203-4.576-.595l-5.304 2.293 1.638-5.232c-1.299-1.616-2.122-3.7-2.122-5.6 0-5.02 5.014-8.507 10.5-8.507z"/>
                    </svg>
                </button>
            )}
        </>
    );
};

export default Footer;
